import { HIS_TYPE_OPTIONS } from '../HIS_TYPE_OPTIONS';
import { HisTypeOptionIdType } from '../types';

export const getHisTypeTitleById = (
  id: HisTypeOptionIdType | null | undefined,
): string | null => {
  if (!id) return null;
  return HIS_TYPE_OPTIONS.find((option) => option.id === id)?.title || null;
};

const DEFAULT: HisTypeOptionIdType = 'twink';
export const getHisTypeIdByTitle = (
  title: string | null | undefined,
  withDefault = false,
): HisTypeOptionIdType | null => {
  const id = HIS_TYPE_OPTIONS.find((option) => option.title === title)?.id;

  if (id) {
    return id;
  }
  if (withDefault) {
    return DEFAULT;
  }
  return null;
};
